const invoiceList = [
  {
    id: 1,
    image: "image1",
    founder: "Aryan Khan",
    founderAt: "Karachi",
    invoiceID: "14251",
    company: "IDC",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Visa ending **** 4242",
    email: "IDC@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 2,
    image: "image2",
    founder: "Aryan Khan",
    founderAt: "Islamabad",
    invoiceID: "142151",
    company: "Excel",
    invoicePrice: "12455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Visa ending **** 4242",
    email: "excel@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 3,
    image: "image3",
    founder: "Aryan Khan",
    founderAt: "Islamabad",
    invoiceID: "14251",
    company: "Shifa",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "MasterCard ending **** 4242",
    email: "Shifa@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 4,
    image: "image4",
    founder: "Aryan Khan",
    founderAt: "Karachi",
    invoiceID: "14251",
    company: "Excel",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Visa ending **** 4242",
    email: "Excel@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 5,
    image: "image5",
    founder: "Aryan Khan",
    founderAt: "Islamabad",
    invoiceID: "14251",
    company: "IDC",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Paypak ending **** 4242",
    email: "IDC@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 6,
    image: "image1",
    founder: "NoOne",
    founderAt: "Islamabad",
    invoiceID: "14251",
    company: "NGO",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Paypak ending **** 4242",
    email: "IDC@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 1,
    image: "image1",
    founder: "Aryan Khan",
    founderAt: "Karachi",
    invoiceID: "14251",
    company: "IDC",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Visa ending **** 4242",
    email: "IDC@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 2,
    image: "image2",
    founder: "Aryan Khan",
    founderAt: "Islamabad",
    invoiceID: "142151",
    company: "Excel",
    invoicePrice: "12455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Visa ending **** 4242",
    email: "excel@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
  {
    id: 5,
    image: "image5",
    founder: "Aryan Khan",
    founderAt: "Islamabad",
    invoiceID: "14251",
    company: "IDC",
    invoicePrice: "1455",
    date: "10 Oct, 19",
    color: "primary",
    orderId: "12345",
    billingAddress: "CUI, Park Road Islamabad",
    shippingAddress: "CUI, Park Road Islamabad",
    card: "Paypak ending **** 4242",
    email: "IDC@lab.org.com",
    orderDate: "October 16, 2022",
    orderSummary: {
      items: [
        {
          id: 1,
          item: "Pending Payment For August",
          price: "PKR " + 499.0 * 200,
        },
        {
          id: 2,
          item: "Pending Payment For July",
          price: "PKR " + 399.0 * 200,
        },
      ],
      subTotal: "PKR " + 1397.0 * 200,
      shipping: "PKR " + 13.0 * 200,
      total: "PKR " + 1410.0 * 200,
    },
  },
];

export { invoiceList };
